<div class="modal-header w-100 p-0">
    <div
        class="w-100 plate plate-primary_blue px-2 pt-3 pb-2 border-bottom-left-radius-0 border-bottom-right-radius-0 border-top-left-radius-modal border-top-right-radius-modal">
        <div class="d-flex justify-content-start align-items-center w-100 plate-header">
            <span class="text-white text-size-16 ml-2 line-height-16">Pilot Track Assessment</span>
        </div>
    </div>
</div>
<div class="modal-body">
    <div class="px-3 mt-2 pb-4">
        <div class="row">
            <span class="text-size-22 pb-2 font-weight-bold">
                What's your current experience level with aviation?
            </span>
        </div>

        <div class="row">
            <span class="text-size-12 line-height-14 font-weight-light pb-4">
                Select One
            </span>
        </div>

        <div class="row pb-1">
            <div class="btn btn-round" (click)="changeExperience(false)" [ngClass]="{'btn-primary': !hasExperience, 'btn-border-gray': hasExperience}">
                No experience
                <app-icon *ngIf="!hasExperience" glyph name="tick-white" class="ml-2"></app-icon>
            </div>
        </div>
        <div class="row pb-4">

            <div class="btn btn-round" (click)="changeExperience(true)" [ngClass]="{'btn-primary': hasExperience, 'btn-border-gray': !hasExperience}">
                I already have a license
                <app-icon *ngIf="hasExperience" glyph name="tick-white" class="ml-2"></app-icon>
            </div>
        </div>
    </div>
</div>


<div class="modal-footer d-flex justify-content-between px-4">
    <div class="text-dark cursor-pointer" (click)="closeModal();">
        <span class="text-size-14">Back</span>
    </div>
    <div class="d-flex justify-content-start">
        <div (click)="closeModal();" class="btn btn-primary btn-round">Continue</div>
    </div>
</div>